export class Atividade {
    constructor(
        public id: number,
        public proximaExecucao: string,
        public espacamento: number,
    ) {}
}
